import {
  Divider,
  Heading,
  HStack,
  IconButton,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";

import { services } from "../data";

const ServicesPanel = () => {
  return (
    <>
      <Heading size="md" my={2}>
        What We Offer
      </Heading>
      <Text fontSize={{ base: "xs", md: "sm" }} color="gray.600" mb={8}>
        Below are some of the most common services we offer, but this is not an
        exhaustive list. If you don’t see what you need, feel free to contact
        us— we’re happy to help with a wide range of jobs!
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} width="100%">
        {services.map((service) => (
          <VStack
            bg="gray.50"
            boxShadow="base"
            key={service.name}
            align="start"
            spacing={2}
            p={4}
            borderRadius="sm"
            border="1px solid"
            borderColor="gray.200"
            width="100%"
          >
            {/* Service Title & Divider */}
            <HStack width="100%" align="center" spacing={4}>
              <IconButton
                bg="gray.700"
                color="white"
                p={1}
                as={service.icon}
                pointerEvents="none" 
              />

              <Heading size="sm">{service.name}</Heading>

              {/* Divider starts after the title and runs to the end */}
              <Divider flex="1" borderWidth="1px" borderColor="gray.300" />
            </HStack>

            {/* Subcategories in Horizontal List */}
            <HStack overflowX="auto" spacing={3} py={2} px={2} width="100%">
              <HStack spacing={4} flexWrap="wrap">
                {service.subcategories.map((sub, index) => (
                  <Text key={index} fontSize="sm">
                    • {sub}
                  </Text>
                ))}
              </HStack>
            </HStack>
          </VStack>
        ))}
      </SimpleGrid>
    </>
  );
};

export default ServicesPanel;
